import { render, staticRenderFns } from "./SampleWorkingMain.vue?vue&type=template&id=00cb7b82&scoped=true"
import script from "./SampleWorkingMain.vue?vue&type=script&lang=js"
export * from "./SampleWorkingMain.vue?vue&type=script&lang=js"
import style0 from "./SampleWorkingMain.vue?vue&type=style&index=0&id=00cb7b82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb7b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00cb7b82')) {
      api.createRecord('00cb7b82', component.options)
    } else {
      api.reload('00cb7b82', component.options)
    }
    module.hot.accept("./SampleWorkingMain.vue?vue&type=template&id=00cb7b82&scoped=true", function () {
      api.rerender('00cb7b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleWorkingMain.vue"
export default component.exports